import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "./assets/css/app.styl";

createApp(App).use(router).mount("#app");
